module.exports = __webpack_public_path__ + "files/a4c4e2b85837175726f4938ef0e94a96.png";